import type { ColumnDef } from '@tanstack/react-table';
import { ActionIcon, Badge, Group, Text, Tooltip } from '@mantine/core';
import { IconEdit, IconFileTypePdf, IconTrash } from '@tabler/icons-react';
import type { ICotizacionServiciosResumen } from '../../../modelos/CotizadorServicios/entidades/ICotizacionServicios';
import { formatoMoneda } from '../interfaces';

interface ColumnasTablaCotizacionesServiciosParams {
    alEditar: (cotizacion: ICotizacionServiciosResumen) => void;
    alGenerarPdf: (cotizacion: ICotizacionServiciosResumen) => void;
    alEliminar: (cotizacion: ICotizacionServiciosResumen) => void;
}

const estiloTooltip = { fontSize: '10px', padding: '3px 5px' };

export const columnasTablaCotizacionesServicios = ({ alEditar, alGenerarPdf, alEliminar }: ColumnasTablaCotizacionesServiciosParams): ColumnDef<ICotizacionServiciosResumen>[] => [
    {
        id: 'actions',
        header: 'Acciones',
        cell: ({ row }) => (
            <Group gap={4} justify="center" wrap="nowrap">
                <Tooltip label="Editar" style={estiloTooltip} withArrow>
                    <ActionIcon color="var(--mantine-color-primary-0)" variant="transparent" radius="sm" size="sm" onClick={() => alEditar(row.original)}>
                        <IconEdit size={18} />
                    </ActionIcon>
                </Tooltip>
                <Tooltip label="Generar PDF" style={estiloTooltip} withArrow>
                    <ActionIcon color="var(--mantine-color-primary-0)" variant="transparent" radius="sm" size="sm" onClick={() => alGenerarPdf(row.original)}>
                        <IconFileTypePdf size={18} />
                    </ActionIcon>
                </Tooltip>
                <Tooltip label="Eliminar" style={estiloTooltip} withArrow>
                    <ActionIcon color="var(--mantine-color-primary-0)" variant="transparent" radius="sm" size="sm" onClick={() => alEliminar(row.original)}>
                        <IconTrash size={18} />
                    </ActionIcon>
                </Tooltip>
            </Group>
        )
    },
    { accessorKey: 'Proyecto', header: 'Proyecto', cell: ({ row }) => <Text size="xs" fw={600}>{row.original.Proyecto}</Text> },
    { accessorKey: 'Cliente', header: 'Cliente', cell: ({ row }) => <Text size="xs">{row.original.Cliente}</Text> },
    { accessorKey: 'Anio', header: 'Año', cell: ({ row }) => <Text size="xs">{row.original.Anio}</Text> },
    {
        id: 'equipos',
        header: 'Equipos',
        cell: ({ row }) => <Text size="xs">{row.original.TotalAscensores} asc. · {row.original.TotalEscaleras} esc.</Text>
    },
    { accessorKey: 'TotalPlanConekta', header: 'Plan Conekta (sin IVA)', cell: ({ row }) => <Text size="xs">{formatoMoneda(row.original.TotalPlanConekta)}</Text> },
    { accessorKey: 'TotalPlanConektaPlus', header: 'Plan Conekta Plus (sin IVA)', cell: ({ row }) => <Text size="xs">{formatoMoneda(row.original.TotalPlanConektaPlus)}</Text> },
    {
        id: 'estado',
        header: 'Estado',
        cell: ({ row }) => <Badge size="sm" variant="light" style={{ textTransform: 'none' }}>{row.original.Estado?.Nombre ?? 'Borrador'}</Badge>
    },
    { accessorKey: 'UsuarioCreadorNombre', header: 'Elaboró', cell: ({ row }) => <Text size="xs">{row.original.UsuarioCreadorNombre ?? '-'}</Text> },
    {
        accessorKey: 'FechaCreacion',
        header: 'Fecha',
        cell: ({ row }) => <Text size="xs">{new Date(row.original.FechaCreacion).toLocaleDateString('es-CO')}</Text>
    }
];
